import About from './components/AboutUs';
import Banner from './components/Banner';
import Companies from './components/Companies';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

function App() {
  return (
    <div className=" font-poppins text-[#2E2E2E]">
      <Navbar />
      <Banner />
      <About />
      <Companies />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
